import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { PRIMARY_BLACK } from "../constants";

const wrapperCss = css({
    "padding": "19px 16px",
    "border": "2px #DCDFE4 solid !important",
    "borderRadius": "8px",
    "minWidth": "400px",
    "cursor": "pointer",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "&:hover": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        borderColor: "#0C66E4 !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label": {
        alignItems: "center",
        cursor: "pointer",
        textAlign: "left"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label span": {
        margin: "0 auto 0 4px",
        cursor: "pointer"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "input": {
        cursor: "pointer"
    }
});

const headerCss = css({
    fontFamily: wacToken("font.charlie.display"),
    fontWeight: 600,
    color: `${PRIMARY_BLACK}`,
    fontSize: "1rem",
    lineHeight: "1.2rem",
    textAlign: "left"
});

const bodyCss = css({
    fontFamily: wacToken("font.charlie.display"),
    color: `${token("color.text.subtle")}`
});

interface ProjectLandingSelectorButtonProps {
    key: string;
    header: string;
    body: string;
    isChecked: boolean;
    onClickFunc: () => void;
}

export const ProjectLandingSelectorButton = ({
    header,
    body,
    isChecked,
    onClickFunc
}: ProjectLandingSelectorButtonProps) => {
    return (
        <button
            css={[
                wrapperCss,
                // eslint-disable-next-line local/ensure-wac-token-usage
                isChecked === true && css({ borderColor: "#0C66E4 !important" })
            ]}
            onClick={(e) => {
                e.preventDefault();
                onClickFunc();
            }}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    onClickFunc();
                }
            }}
        >
            <div css={headerCss}>{header}</div>
            <div css={bodyCss}>{body}</div>
        </button>
    );
};
